import { useState } from "react";
import { ConfirmationModal } from "@libs/zapi-ui/custom";
import { ChatAskMessageList } from "./ChatTestMessageList";
import { ChatTestForm, ChatMode } from "./ChatTestForm";
import { useChatTest } from "../hooks/useChatTest";
import { ChatIsland } from "@/zapi-frontend/widgets/ChatIsland";
import { ModeToggle } from "./ModeToggle";
import { ENABLE_ASK_CHAT } from "@/zapi-frontend/shared/const/consts";

type Props = {
  chapterName?: string;
};

export function ChatTestIsland({ chapterName }: Props) {
  const [mode, setMode] = useState<ChatMode>(ENABLE_ASK_CHAT ? "ask" : "edit");
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const askHook = useChatTest();

  return (
    <div className="flex flex-col h-full">
      {ENABLE_ASK_CHAT && (
        <ModeToggle mode={mode} onModeChange={setMode} chapterName={chapterName} />
      )}

      {mode === "ask" && (
        <>
          <ChatAskMessageList
            messages={askHook.messages}
            streamingContent={askHook.streamState.currentContent}
            isStreaming={askHook.streamState.isStreaming}
            statusMessage={askHook.streamState.statusMessage}
          />

          <ChatTestForm
            isStreaming={askHook.streamState.isStreaming}
            onSubmit={askHook.handleSubmit}
            onClearChat={() => setIsConfirmOpen(true)}
            onAbort={askHook.handleAbort}
            hasMessages={askHook.hasMessages}
          />

          <ConfirmationModal
            isOpen={isConfirmOpen}
            onConfirm={() => {
              askHook.handleClearChat();
              setIsConfirmOpen(false);
            }}
            onClose={() => setIsConfirmOpen(false)}
            title="Clear chat"
            description="Are you sure you want to clear the chat?"
          />
        </>
      )}

      {mode === "edit" && <ChatIsland />}
    </div>
  );
}
